module.exports = __webpack_public_path__ + "img/wheel_buyfeature_super_info.39286f21.png";